<template>
  <modal :title="$t('device.history')" :visible.sync="isShowDialog" width="1100px" append-to-body @close="close">

    <div class="uk-flex">
      <el-date-picker
          style="width:350px;"
          v-model="time"
          type="datetimerange"
          :range-separator="$t('public.to')"
          :start-placeholder="$t('public.start_date')"
          :end-placeholder="$t('public.end_date')"
          value-format="timestamp"
          align="left"
          @change="changeTime"
      >
      </el-date-picker>
      <el-select v-model="tableModel.type" class="ml-5 input-width">
          <el-option :label="$t(item.title)" :value="parseInt(key)" :key="key"
              v-for="(item, key) in switchType"></el-option>
      </el-select>
        <el-input class="ml-5 input-width" v-model="tableModel.deviceCode"
            :placeholder="$t('integration.equipment_no')"></el-input>
          <el-input class="ml-5 input-width" v-model="tableModel.userName"
            :placeholder="$t('placeholderText.EnterUserName')"></el-input>
        <div class="ml-5">
            <el-button type="primary" icon="el-icon-search" @click="getListFn"></el-button>
            <el-button icon="el-icon-refresh" @click="resetCondition"></el-button>
        </div>
    </div>
    <el-button
      type="primary"
      style="margin: 5px 0;"
      @click="delHistoryBatch"
    >
      {{ $t('public.btn_delete') }}
    </el-button>
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      max-height="400"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createTime"
        :label="$t('integration.operation_time')"
        width="180"
        align="center">
        <template #default="{row}">
          {{ $timetransition(row.createTime)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('device.switch')"
        align="center"
        width="300"
      >
        <template #default="{row}">
          <div class="uk-flex-1 uk-flex uk-text-center"
            v-if="row.newDeviceCode" >
            <div style="background-color: var(--primary-color); color: #fff;padding: 0 4px;">
              {{ row.originDeviceCode? row.originDeviceCode :  $t('暂未绑定设备')}}
            </div>
            <div class="bd-l bd-t bd-r bd-b" style="width:30px;">
              <i class="el-icon-right"></i>
            </div>
            <div style="background-color: orange; color: #fff;padding: 0 4px;">
              {{ row.newDeviceCode }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        :label="$t('public.status')"
        width="70"
        align="center">
          <template #default="{row}">
            {{ switchStatusConvert(row.status) }}
          </template>
      </el-table-column>
      <el-table-column
        prop="status"
        :label="$t('tableTitle.Result')"
        width="50"
        align="center">
          <template #default="{row}">
            <div v-if="row.status === 2 || row.status === 3">
              <i v-if="row.status === 2" class="el-icon-circle-check" style="color: #70b700; font-size: 20px;"></i>
              <i v-else class="el-icon-circle-close" style="color: red; font-size: 20px;"></i>
            </div>
          </template>
      </el-table-column>
      <el-table-column
        :label="$t('device.time')"
        width="80"
        align="center">
          <template #default="{row}">
            <el-tooltip effect="dark"
              v-if="(row.status === 2 || row.status === 3) && row.endTime && row.startTime"
              :content="$t('device.complete_switch') + $t('public.time') + ':' + $timetransition(row.endTime)"
              placement="top-start">
              <div>{{ $getDiffDays(row.endTime, row.startTime) }}</div>
            </el-tooltip>
          </template>
      </el-table-column>
      <el-table-column
        prop="type"
        :label="$t('device.switch_type')"
        width="80"
        align="center">
          <template #default="{row}">
            {{ $t(switchTypeConvert(row.type).title) }}
          </template>
      </el-table-column>
      <el-table-column
        prop="result"
        :label="$t('tableTitle.remark')"
        align="center">
        <template #default="{row}">
          {{switchResultConvert(row.result)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="operationUser"
        :label="$t('tableTitle.OperatingUser')"
        width="80"
        align="center">
      </el-table-column>
      <el-table-column
        prop="operationTime"
        :label="$t('tableTitle.Operating')"
        width="50"
        align="center">
        <template #default="{row}">
          <i class="el-icon-delete cursor-pointer" style="color: red;font-size: 20px;"  @click="delHistory(row)"></i>
        </template>
      </el-table-column>

    </el-table>
  </modal>

</template>

<script>

import { carrierDelHistory, carrierDelHistoryBatch, getCarrierHistory } from '@/api/modules/carrier'
import { switchTypeConvert, switchResultConvert, switchType, switchStatusConvert } from '@/utils/convert'
export default {
  name: 'SwitchHistory',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    deviceId: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      switchType,
      tableModel: {
        carrierDeviceId: null,
        endTime: null,
        startTime: null,
        type: null,
        deviceCode: null,
        userName: null
      },
      time: [],
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    switchTypeConvert: () => switchTypeConvert,
    switchResultConvert: () => switchResultConvert,
    switchStatusConvert: () => switchStatusConvert

  },
  watch: {
    isShowDialog(){
      if(this.isShowDialog){
        this.getListFn()
      }
    }
  },
  methods: {
    // 获取历史列表
    getListFn(){
      this.tableModel.carrierDeviceId = this.deviceId
      getCarrierHistory(this.tableModel).then(res => {
        const { pageInfo, result } = res.result
        this.total = pageInfo.total
        this.tableData = result
      })
    },
    // 单个删除切换历史
    delHistory(row){
      carrierDelHistory({id: row.id}).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          this.getListFn()
        }
      })
    },
    // 批量删除
    delHistoryBatch(){
      if(!this.multipleSelection.length){
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      let ids = this.multipleSelection.map(_ => _.id)
      carrierDelHistoryBatch(ids).then( res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          this.getListFn()
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    resetCondition () {
     this.tableModel = {
        deviceCode: null,
        operationUser: null,
        startTime: null,
      }
      this.getListFn()
    },
    close(){
      this.$emit('close')
    },
    changeTime(e){
      console.log(e)
      console.log(this.time)
      this.tableModel.startTime = this.time ? this.time[0] : null
      this.tableModel.endTime = this.time ? this.time[1] : null
    }
  }
}
</script>

<style lang="scss" scoped>
.input-width.el-input, .input-width.el-select {
  width: 160px;
}
::v-deep .el-table .cell {
  padding: 4px 6px;
}

</style>
